import { useState } from "react";
import { faqs } from "@/mocks/gossip";
import SectionHeading from "./SectionHeading";

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-background-100 py-14 md:py-20">
      <div className="container-x grid gap-10 lg:grid-cols-[0.4fr_0.6fr] lg:items-start">
        <div className="lg:sticky lg:top-24">
          <SectionHeading
            eyebrow="FAQ"
            title="关于本月大瓜的常见问题"
            desc="关于本站的定位、信息来源与时间线的阅读方式，这里集中回答最常被问到的问题。"
          />
          <div className="mt-6 hidden items-center gap-3 rounded-xl bg-accent-100/70 p-5 ring-1 ring-accent-200 lg:flex">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-accent-500 text-foreground-950">
              <i className="ri-question-line text-xl"></i>
            </span>
            <p className="text-sm leading-6 text-accent-900">
              没找到答案？查看页面底部的联系方式，随时可以向我们反馈线索。
            </p>
          </div>
        </div>

        <div className="space-y-3">
          {faqs.map((f, i) => {
            const open = openIdx === i;
            return (
              <div
                key={f.q}
                className={`overflow-hidden rounded-xl bg-background-50 ring-1 transition-colors ${
                  open ? "ring-primary-300" : "ring-background-200 hover:ring-background-300"
                }`}
              >
                <h3>
                  <button
                    type="button"
                    onClick={() => setOpenIdx(open ? null : i)}
                    className="flex w-full items-center gap-3 px-5 py-4 text-left"
                    aria-expanded={open}
                  >
                    <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-primary-100 text-primary-700">
                      <i className="ri-question-line text-sm"></i>
                    </span>
                    <span className="flex-1 text-[15px] font-semibold text-foreground-950 md:text-base">{f.q}</span>
                    <i className={`ri-arrow-down-s-line shrink-0 text-xl text-foreground-400 transition-transform duration-300 ${open ? "rotate-180 text-primary-600" : ""}`}></i>
                  </button>
                </h3>
                <div
                  className={`grid transition-[grid-template-rows] duration-300 ease-out ${
                    open ? "grid-rows-[1fr]" : "grid-rows-[0fr]"
                  }`}
                >
                  <div className="overflow-hidden">
                    <div className="px-5 pb-5 pl-14">
                      <p className="text-sm leading-7 text-foreground-600">{f.a}</p>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}